/* eslint-disable @typescript-eslint/no-misused-promises */
import Btn from 'components/btn';
import FormSelect, { FormSelectGroup, FormSelectOption } from 'components/form/select';
import DatePicker from 'react-datepicker';
import FormTextfield from 'components/form/textfield';
import {
  Controller, FormProvider, useForm,
} from 'react-hook-form';
import { DatePickerInputWrapper } from 'components/form/textfieldDatepicker';
import {
  MouseEvent, useEffect, useRef, useState,
} from 'react';
import FilterIcon from 'assets/icons/filter.svg';
import { format } from 'date-fns';
import { getLaminasApiData } from 'services/api';

// const fromSelectData: FormSelectGroup[] = [
//   {
//     label: 'Group A',
//     options: [
//       {
//         value: 'aa',
//         label: 'hello aa',
//         isDisabled: false,
//       },
//       {
//         value: 'ab',
//         label: 'hello ab',
//         isDisabled: false,
//       },
//       {
//         value: 'ac',
//         label: 'hello ac',
//         isDisabled: true,
//       },
//     ],
//   },
//   {
//     label: 'Group B',
//     options: [
//       {
//         value: 'ba',
//         label: 'hello ba',
//         isDisabled: false,
//       },
//       {
//         value: 'bb',
//         label: 'hello bb',
//         isDisabled: true,
//       },
//       {
//         value: 'bc',
//         label: 'hello bc',
//         isDisabled: false,
//       },
//     ],
//   },
// ];

const fromSelectData: FormSelectGroup[] = [
  {
    label: '',
    options: [
      {
        value: 'aa',
        label: 'hello aa',
        isDisabled: false,
      },
      {
        value: 'ab',
        label: 'hello ab',
        isDisabled: false,
      },
      {
        value: 'ac',
        label: 'hello ac',
        isDisabled: true,
      },
    ],
  },
];

interface OverviewFilters {
  platforms: FormSelectOption[];
  customNames: FormSelectOption[];
}

export default function UiForm() {
  const formMethods = useForm({
    mode: 'onChange',
    defaultValues: {
      selectA: 'aa',
      datePickerA: '',
      search: '',
    },
  });

  const [isOpen, setIsOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const prevFilterRef = useRef<string | null>(null);

  const onSubmit = (data: unknown) => {
    console.log(data);
  };

  const getOverviewFilters = () => getLaminasApiData<OverviewFilters>('/tx-overview-v1/overview/filters');

  useEffect(() => {
    const subscription = formMethods.watch((data) => {
      const date = data.datePickerA;
      const formatedData = {
        ...data,
        datePickerA: date ? format((date as unknown as Date), 'yyyy-MM-dd') : undefined,
      };

      const filterString = (Object.keys(formatedData) as Array<keyof typeof formatedData>)
        .reduce((acc, key) => {
          const value = formatedData[key];

          if (value !== undefined && value !== '') {
            switch (key) {
              case 'search':
                acc.push(`searchTerm=${formatedData[key] as string}`);
                break;

              case 'datePickerA':
                acc.push(`dateModified=${formatedData[key] as string}`);
                break;

              case 'selectA':
                acc.push(`selectA=${formatedData[key] as unknown as string}`);
                break;

              default:
                break;
            }
          }

          return acc;
        }, [] as string[]).join('&');

      // no change in string
      if (prevFilterRef.current && prevFilterRef.current === filterString) return;

      prevFilterRef.current = filterString;
      console.log('filterString', filterString);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [formMethods.watch]);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();

    setIsOpen(!isOpen);

    getOverviewFilters()
      .then((res) => {
        const filters = res.data;
        console.log(filters);
      }, () => { });
  };

  return (
    <FormProvider {...formMethods}>
      <form className="ct_form" onSubmit={formMethods.handleSubmit(onSubmit)}>

        <div className={`ct_tableFilter ${isOpen ? '_open' : ''}`}>
          <div className="ct_tableFilter-header">
            <div className="ct_tableFilter-search">
              <FormTextfield
                name="search"
                options={{ maxLength: 15, required: true }}
                placeholder="Search"
                debounceMs={400}
              />
            </div>
            <div className="ct_tableFilter-action">
              <Btn onClick={(e: unknown) => handleClick(e as MouseEvent)} type="link" text="Show Filters" icon={<FilterIcon />} />
            </div>
          </div>
          {!!isOpen && (
          <div className="ct_tableFilter-content">
            <div className="ct_form-row">
              <div className="ct_form-col">
                <Controller
                  control={formMethods.control}
                  name="selectA"
                  rules={{ required: true }}
                  render={({ field: { name, value, onChange }, formState }) => (
                    <FormSelect
                      name={name}
                      label="SelectA"
                      groups={fromSelectData}
                      filterByKey="label"
                      labelKey="label"
                      disabled={false}
                      valueKey="value"
                      value={value}
                      clearable
                      searchable
                      onChange={onChange}
                      errors={formState.errors}
                    />
                  )}
                />
              </div>
              <div className="ct_form-col">
                <Controller
                  name="datePickerA"
                  control={formMethods.control}
                  rules={{ required: true }}
                  render={({ field: { name, value, onChange }, formState }) => (
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={value}
                      onChange={onChange}
                      onCalendarOpen={() => setIsCalendarOpen(true)}
                      onCalendarClose={() => setIsCalendarOpen(false)}
                      name={name}
                      disabled={false}
                      placeholderText="Date"
                      customInput={(
                        <DatePickerInputWrapper
                          onClearCB={() => formMethods.setValue('datePickerA', '')}
                          isOpen={isCalendarOpen}
                          errors={formState.errors}
                          label="Date modified"
                          clearable
                        />
                      )}
                      calendarStartDay={1}
                      popperplacement="bottom-start"
                      popperModifiers={[
                        {
                          name: 'flip',
                          enabled: false,
                        },
                      ]}
                    />
                  )}
                />
              </div>
            </div>
          </div>
          )}
        </div>

        <Btn
          btnType="submit"
          type="primary"
          text="Submit"
          disabled={!formMethods.formState.isValid}
        />
      </form>
    </FormProvider>

  );
}
